import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DoctorSocialService } from '../doctor-social.service';
import { AppService, response } from 'src/app/app.service';
import { ToastrService } from 'ngx-toastr';
import { getLinkPreview } from "link-preview-js";

@Component({
  selector: 'app-post-feed-dialog',
  templateUrl: './post-feed-dialog.component.html',
  styleUrls: ['./post-feed-dialog.component.css']
})
export class PostFeedDialogComponent implements OnInit {

  form: FormGroup;
  categories

  @ViewChild("photoInput", { static: false }) photoInput: any;
  @ViewChild("videoInput", { static: false }) videoInput: any;


  imagesToAdd: any[] = [];
  imagesToPreview: any[] = [];

  linkUrl = new FormControl(null)

  fileType = null

  selectedChips = [
    { categoryName: "#value1", categoryId: 1 },
    { categoryName: "#value2", categoryId: 2 },
    { categoryName: "#value3", categoryId: 3 },
    { categoryName: "#value4", categoryId: 4 },
    { categoryName: "#value5", categoryId: 5 },
    { categoryName: "#value6", categoryId: 6 },
  ]

  selectedChipsValues: any = []

  constructor(
    public dialogRef: MatDialogRef<PostFeedDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private service: DoctorSocialService,
    public app: AppService,
    private toaster: ToastrService,
  ) { }


  ngOnInit(): void {
    this.form = new FormGroup({
      PostType: new FormControl("1"),
      PostText: new FormControl(""),
      EnableComments: new FormControl(true),
      PostCategories: new FormControl([]),
      Media: new FormControl([]),
    });
    this.getCategories();
  }

  get = (formControlName: string) => this.form.get(formControlName) as FormControl;

  cancel(): void {
    this.dialogRef.close();
  }


  // enum MediaType: Int {
  //   case PHOTO = 1
  //   case VIDEO = 2
  //   case LINK = 3
  // }

  checkValidityForm = (): Promise<Boolean> => {
    // Check Form Validity 
    if (this.form.invalid) {
      if (this?.app?.getUserLanguage() == 'en') {
        this.toaster.error("Please Fill out all required inputs.");
      } else if (this?.app?.getUserLanguage() == 'ar') {
        this.toaster.error("يرجى ملء جميع المدخلات المطلوبة.");
      }
      this.form.markAllAsTouched();
      this.createBtnDisable = false
      return Promise.resolve(false);
    }

    if (this.fileType == 1 && this.imagesToAdd.length > 7 || this.fileType == 2 && this.imagesToAdd.length > 1) {
      this.createBtnDisable = false
      return Promise.resolve(false);
    }

    if (this.fileType == 3 && !this?.linkUrl?.value) {
      if (this?.app?.getUserLanguage() == 'en') {
        this.toaster.error("Please Fill out all required inputs.");
      } else if (this?.app?.getUserLanguage() == 'ar') {
        this.toaster.error("يرجى ملء جميع المدخلات المطلوبة.");
      }
      this.createBtnDisable = false
      return Promise.resolve(false);
    }

    if (this.fileType == null && (this.get("PostText").value.length == 0 || this.get("PostText").value.trim().length === 0)) {
      if (this?.app?.getUserLanguage() == 'en') {
        this.toaster.error("Please type your post or pick media");
      } else if (this?.app?.getUserLanguage() == 'ar') {
        this.toaster.error("يرجى كتابة منشورك أو اختيار احدى الوسائط");
      }
      this.createBtnDisable = false
      return Promise.resolve(false);
    }

    if (!this?.app?.IsSocialMediaManager && !this?.app?.isContributor) {
      if(this.get("PostCategories").value.length == 0){
        if (this?.app?.getUserLanguage() == 'en') {
          this.toaster.error("Please choose at least one topic");
        } else if (this?.app?.getUserLanguage() == 'ar') {
          this.toaster.error("يرجى اختيار موضوع واحد على الأقل");
        }
        this.createBtnDisable = false
        return Promise.resolve(false);
      }
    }
    
    return Promise.resolve(true) as Promise<Boolean>;
  }

  getRequestPayLoad = (): FormData => {
    let request = new FormData();
    request.append("PostType", this.get("PostType").value);
    request.append("PostText", this.get("PostText").value);
    request.append("EnableComments", this.get("EnableComments").value);

    this.get("PostCategories").value.length > 0 && this.get("PostCategories").value.map(item => request.append("PostCategories", item))

    if (this.fileType == 1 || this.fileType == 2) {
      this.get("Media").value.length > 0 && this.get("Media").value.map((item, index) => {
        let objName = `Media[${index}].File`
        let objType = `Media[${index}].FileType`
        let objValue = item?.File
        let objValueType = item?.FileType
        request.append(objName, objValue)
        request.append(objType, objValueType)
      })
    } else if (this?.fileType == 3) {
      request.append("Media[0].LinkUrl", this?.linkUrl?.value)
      request.append("Media[0].FileType", this?.fileType)
    }

    // this.get("Media").value.length > 0 && this.get("Media").value.map(item => request.append("Media", item))

    return request;
  }

  createBtnDisable: boolean = false
  submit = async (): Promise<void> => {
    this.createBtnDisable = true
    this.app.showLoading();

    // console.warn(this.form.value)

    // return

    await this.checkValidityForm() && this.service.postFeed(await this.getRequestPayLoad()).subscribe((res: response) => {
      if (res.errorCode == 0) {

        if (this?.app?.getUserLanguage() == 'en') {
          this.toaster.success("Posted Successfully");
        } else if (this?.app?.getUserLanguage() == 'ar') {
          this.toaster.success("تم النشر بنجاح");
        }
        this.dialogRef.close(true);
      }
      if (res.errorCode != 0) {
        if (this?.app?.getUserLanguage() == 'en') {
          this.toaster.error("Something went wrong");
        } else if (this?.app?.getUserLanguage() == 'ar') {
          this.toaster.error("حدث خطأ ما");
        }
        this.createBtnDisable = false
      }
    })
    this.app.dismissLoading();
  }



  updateChips = (value: any) => {
    let index = this.selectedChipsValues.indexOf(value);
    index == -1 ? this.selectedChipsValues.push(value) : this.selectedChipsValues.splice(index, 1);

    let categoriesForm = this.get("PostCategories").value
    let indexCategories = categoriesForm.indexOf(value);
    indexCategories == -1 ? categoriesForm.push(value) : categoriesForm.splice(indexCategories, 1);
    this.get("PostCategories").setValue(categoriesForm)
  }

  async readUrl(event: any) {
    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      let x: string = event.target.files[0].type
      if (x.includes('video')) {
        this.fileType = 2
        if (filesAmount > 1) {
          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.info("Videos limit is 1");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.info("الحد الأقصى لعدد مقاطع الفيديو هو 1");
          }
          return
        }
      } else if (x.includes('image')) {
        this.fileType = 1
        if (filesAmount > 7) {
          if (this?.app?.getUserLanguage() == 'en') {
            this.toaster.info("Images limit is 7");
          } else if (this?.app?.getUserLanguage() == 'ar') {
            this.toaster.info("الحد الأقصى للصور هو 7");
          }
          return
        }
      }
      if (this.imagesToAdd.length != 0) {
        if (await this.checkValidVideoImages(filesAmount) == false) { return }
      }
      for (let i = 0; i < filesAmount; i++) {
        // toAddPreview
        const reader = new FileReader();
        reader.onload = (event2: any) => {
          this.imagesToPreview.push({
            image: event2.target.result,
            imageName: event.target.files[i].name
          });
        };
        // toAddPreview
        // toAddActualImage
        if (this.fileType == 1 || this.fileType == 2) {
          this.imagesToAdd.push({
            File: event.target.files[i],
            FileType: this.fileType,
          });
        }
        this.get("Media").setValue(this.imagesToAdd);
        reader.readAsDataURL(event.target.files[i]);
        // toAddActualImage
      }
    }
  }


  checkValidVideoImages = (filesAmount): Promise<Boolean> => {

    const allFilesAmount = filesAmount + this.imagesToAdd.length

    if (this.fileType == 1) {
      if (this.imagesToAdd.every(x => x.FileType == 1) && allFilesAmount <= 7) {
        return Promise.resolve(true) as Promise<Boolean>;
      } else {
        if (this?.app?.getUserLanguage() == 'en') {
          this.toaster.info("Images limit is 7");
        } else if (this?.app?.getUserLanguage() == 'ar') {
          this.toaster.info("الحد الأقصى للصور هو 7");
        }
        return Promise.resolve(false);
      }
    } else if (this.fileType == 2) {
      if (this.imagesToAdd.every(x => x.FileType == 2) && allFilesAmount == 1) {
        return Promise.resolve(true) as Promise<Boolean>;
      } else {
        if (this?.app?.getUserLanguage() == 'en') {
          this.toaster.info("Videos limit is 1");
        } else if (this?.app?.getUserLanguage() == 'ar') {
          this.toaster.info("الحد الأقصى لعدد مقاطع الفيديو هو 1");
        }
        return Promise.resolve(false);
      }
    } else {
      return Promise.resolve(false);
    }
  }


  removeFromImages(image) {
    this.imagesToPreview = this.imagesToPreview.filter(x => x.image != image?.image);
    this.imagesToAdd = this.imagesToAdd.filter(x => x?.File?.name !== image?.imageName);
    this.get("Media").setValue(this.imagesToAdd);
    this.photoInput.nativeElement.value = null;
    this.videoInput.nativeElement.value = null;
    if (this.imagesToAdd.length == 0) {
      this.fileType = null;
    }
  }

  getCategories() {
    this.service.getInterestsRelatedToUser().subscribe(
      res => {
        this.categories = res.data
      }
    )
  }

  addUrlLink() {
    this.fileType = 3
  }

  removeUrlLink() {
    this.fileType = null
    this.linkUrl.setValue(null)
    this.urlData = null
  }


  urlData = null
  urlChangeInput() {
    const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
    setTimeout(async () => {
      if (urlPattern.test(this?.linkUrl?.value)) {

        // getLinkPreview(this?.linkUrl?.value).then((data) => {
        //   const resData: any = data
        //   if (resData?.description) {
        //     this.urlData = data
        //   } else {
        //     if (this?.app?.getUserLanguage() == 'en') {
        //       this.toaster.error("Invalid Link");
        //     } else if (this?.app?.getUserLanguage() == 'ar') {
        //       this.toaster.error("رابط غير صالح");
        //     }
        //     this.removeUrlLink()
        //   }
        // }
        // );

        await this.service.getLinkPreviewData(this?.linkUrl?.value).subscribe(
          res => {
            const resData: any = res
            if (resData) {
              this.urlData = res
            } else {
              if (this?.app?.getUserLanguage() == 'en') {
                this.toaster.error("Invalid Link");
              } else if (this?.app?.getUserLanguage() == 'ar') {
                this.toaster.error("رابط غير صالح");
              }
              this.removeUrlLink()
            }
          }
        )


      } else {
        this.removeUrlLink()
      }
    }, 300);
  }

  urlClicked(url) {
    window.open(url)
  }




}
